const EmployeeActionTypes = {
  SET_DEPARTMENTS: 'SET_DEPARTMENTS',
  REMOVE_DEPARTMENT: 'REMOVE_DEPARTMENT',
  SET_EMPLOYEES: 'SET_EMPLOYEES',
  REMOVE_EMPLOYEE: 'REMOVE_EMPLOYEE',
};

export default EmployeeActionTypes;
